import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { Routes } from '@angular/router';
import { ApiModule, Configuration } from '@intouch/fines-portal-api';
import { UserInfoService } from 'fines-portal/shared/api/data-access/user-info';
import { AuthResponseInterceptor } from 'fines-portal/auth/data-access/auth';
import { Environment } from 'fines-portal/core/data-access/environment';
import { provideFeatureFlag } from 'fines-portal/core/data-access/feature-flag';
import { FileService } from 'fines-portal/shared/api/data-access/file';
import {
    AmplitudeService,
    provideTrackingService,
} from 'shared/core/data-access/analytics';
import { createBaseAppConfig } from 'shared/core/data-access/config';
import { provideUserInfoService } from 'shared/core/data-access/user-info';

export const createAppConfig = (
    environment: Environment,
    routes: Routes,
): ApplicationConfig =>
    createBaseAppConfig(
        environment,
        routes,
        [AuthResponseInterceptor],
        FileService,
        [
            importProvidersFrom(
                ApiModule.forRoot(
                    (): Configuration =>
                        new Configuration({
                            withCredentials: true,
                            basePath: environment.apiBasePath,
                        }),
                ),
            ),
            provideFeatureFlag(environment.flags),
            provideUserInfoService(UserInfoService),
            provideTrackingService(AmplitudeService),
        ],
    );
